import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './VideoChat.css';
import { useHistory } from 'react-router-dom';
import config from '../config';

const VideoChat = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
  });
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [hostStatus, setHostStatus] = useState('available');
  const history = useHistory();

  const validateField = (name, value) => {
    switch (name) {
      case 'name':
        return value.length < 2 ? 'Name must be at least 2 characters' : '';
      case 'company':
        return value.length < 2 ? 'Company name must be at least 2 characters' : '';
      case 'email':
        return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? 'Please enter a valid email' : '';
      case 'phone':
        return !/^[\d\s-+()]{10,}$/.test(value) ? 'Please enter a valid phone number' : '';
      default:
        return '';
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    if (touched[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: validateField(name, value)
      }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched(prev => ({ ...prev, [name]: true }));
    setErrors(prev => ({
      ...prev,
      [name]: validateField(name, value)
    }));
  };
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    const requestData = {
      visitor: {
        name: formData.name,
        company: formData.company,
        email: formData.email,
        phone: formData.phone,
      },
      hostEmail: 'alexren268@gmail.com' // Hardcode this for the landing page
    };
    
    console.log('Sending request with data:', requestData);

    try {
      const response = await axios.post(
        `${config.backendUrl}/api/send-notifications`, 
        requestData,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': config.apiKey
          }
        }
      );

      console.log('Response from send-notifications:', response.data);

      if (response.data.success && response.data.roomUrl) {
        history.push(`/video-chat?roomUrl=${encodeURIComponent(response.data.roomUrl)}`);
      } else {
        throw new Error(response.data.error || 'Failed to create video chat room');
      }
    } catch (error) {
      console.error('Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      setErrors({ 
        submit: error.response?.data?.error || 'Failed to start video chat. Please try again.' 
      });
    } finally {
      setIsLoading(false);
    }
  };

  const isFormValid = () => {
    const hasAllFields = Object.values(formData).every(value => value.trim() !== '');
    const hasErrors = Object.keys(errors).some(key => touched[key] && errors[key]);
    return hasAllFields && !hasErrors;
  };

  useEffect(() => {
    const checkHostStatus = async () => {
      try {
        const response = await fetch(
          `${config.backendUrl}/api/host-status/alexren268@gmail.com`,
          {
            headers: {
              'x-api-key': config.apiKey,
              'Content-Type': 'application/json'
            }
          }
        );
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        console.log('Host status response:', data);
        setHostStatus(data.status);
      } catch (error) {
        console.error('Error checking host status:', error);
        setHostStatus('unavailable');
      }
    };

    checkHostStatus();
    
    return () => clearInterval(intervalId);
  }, []);

  if (hostStatus !== 'online') {
    return (
      <div>
        <h3>I'm currently unavailable</h3>
        <div 
          className="calendly-inline-widget" 
          data-url="https://calendly.com/alexren268/30min"
          style={{ minWidth: '320px', height: '600px' }}
        />
      </div>
    );
  }

  return (
    <div className="chat-container">
      <form onSubmit={handleSubmit} className="chat-form">
        <div className="form-group">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleInputChange}
            onBlur={handleBlur}
            className={errors.name && touched.name ? 'error' : ''}
            required
          />
          {errors.name && touched.name && <span className="error-message">{errors.name}</span>}
        </div>

        <div className="form-group">
          <input
            type="text"
            name="company"
            placeholder="Company"
            value={formData.company}
            onChange={handleInputChange}
            onBlur={handleBlur}
            className={errors.company && touched.company ? 'error' : ''}
            required
          />
          {errors.company && touched.company && <span className="error-message">{errors.company}</span>}
        </div>

        <div className="form-group">
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleInputChange}
            onBlur={handleBlur}
            className={errors.email && touched.email ? 'error' : ''}
            required
          />
          {errors.email && touched.email && <span className="error-message">{errors.email}</span>}
        </div>

        <div className="form-group">
          <input
            type="tel"
            name="phone"
            placeholder="Phone"
            value={formData.phone}
            onChange={handleInputChange}
            onBlur={handleBlur}
            className={errors.phone && touched.phone ? 'error' : ''}
            required
          />
          {errors.phone && touched.phone && <span className="error-message">{errors.phone}</span>}
        </div>

        <button 
          type="submit" 
          className="primary-button chat-button"
          disabled={isLoading || !isFormValid()}
        >
          {isLoading ? 'Starting Chat...' : 'Start Video Chat'}
        </button>
      </form>
    </div>
  );
};

export default VideoChat; 